import type { PreClaimsInitialValuesResponse } from './api';

export const normalizePreClaimsInitialValues = (data: PreClaimsInitialValuesResponse) => {
  if (!data) {
    return null;
  }
  return {
    ...data,
    branchKey: data.branchKey ? data.branchKey : undefined,
    carrierKey: data.carrierKey ? data.carrierKey : undefined,
  };
};
